import AdminProgressReports from "Administrator/routes/ProgressReportSetup/routes/AdminProgressReports";
import ProgressReportTemplate from "Administrator/routes/ProgressReportSetup/routes/ProgressReportTemplate";
import CommentTemplates from "Administrator/routes/ProgressReportSetup/routes/CommentTemplates";
import CheckList from "Administrator/routes/ProgressReportSetup/routes/Checklist";
import VoiceAndOutputStructure from "Administrator/routes/ProgressReportSetup/routes/VoiceAndOutputStructure";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "progressreports",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "progress-report" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    AdminProgressReports(store),
    ProgressReportTemplate(store),
    CommentTemplates(store),
    CheckList(store),
    VoiceAndOutputStructure(store),
  ],
});
